import React, { useContext } from 'react'
import { Button, Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import { FaChevronDown } from 'react-icons/fa'

import { NewContext } from '../../Context/NewContext'

export const PerpageAndDeleteBtn = ({ Icon, delBtn = true, resetFilterBtn = true, name = "10", dropData, deleteUpdateTag, perPageCount = true }) => {
    const { filterDropdown, setFilterDropdown, selectedOptions, setSelectedOptions, setCheckedValues, range, setRange, filterDate, setFilterDate, perPage, setPerPage, setCurrentPage, checkedValues, handleDeleteAll } = useContext(NewContext);
    return (
        <>
            <div className={`flex flex-wrap gap-2`}>
                {
                    perPageCount && perPage > 0 &&
                    <Menu placement='bottom-start'>
                        <MenuHandler>
                            <Button variant='outlined' color='white' className='text-darkblue bg-white border-[#B4BCC9] flex items-center px-4 lg:px-2 2xl:px-4'>
                                <div className='flex mr-2 items-center'>
                                    {/* <Icon size={"22px"} /> */}
                                    <span className='text-[16px] lg:text-[14px] capitalize font-normal'>{perPage}</span>
                                </div>
                                <FaChevronDown size={"12px"} />
                            </Button>
                        </MenuHandler>
                        <MenuList className='border-[#B4BCC9]'>
                            {
                                [5, 10, 15, 20, 25].map((_ele, i) => (
                                    <MenuItem key={i} onClick={() => { setCurrentPage(1); setPerPage(_ele); setCheckedValues([]) }} className={`${perPage == _ele ? `bg-[#0047FF] text-white hover:bg-[#0047FF] hover:text-white focus:bg-[#0047FF] focus:text-white active:bg-[#0047FF] active:text-white` : ``}`}>{_ele}</MenuItem>
                                ))
                            }
                        </MenuList>
                    </Menu>
                }
                {
                    delBtn && checkedValues.length > 0 && <Button className='bg-[#F22F42] shadow-none hover:shadow-none font-medium text-white text-base capitalize lg:text-[14px] lg:px-3' onClick={() => handleDeleteAll(deleteUpdateTag)} disabled={checkedValues?.length === 0}>Delete</Button>
                }
                {
                    resetFilterBtn && (Object.keys(filterDropdown).length > 0 || filterDate) && <Button className='bg-[#F22F42] shadow-none hover:shadow-none font-medium text-white text-base capitalize lg:text-[14px] lg:px-3' onClick={() => { setFilterDropdown({}); setSelectedOptions([]); setRange({}); setFilterDate(""); }} disabled={!Object.keys(filterDropdown).length}>Reset Filters</Button>
                }
            </div>

        </>
    )
}

export default PerpageAndDeleteBtn
